import { Stack } from 'expo-router'

export const unstable_settings = {
  initialRouteName: 'index',
}

export default function TabLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" options={{ title: 'My folders' }} />
      <Stack.Screen name="join" options={{ title: 'Join a folder' }} />
      <Stack.Screen
        name="new-folder"
        options={{
          title: 'Create a folder',
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
        }}
      />
      <Stack.Screen name="(top-tabs)/[folderId]" options={{ title: '' }} />
      <Stack.Screen name="[folderId]/chats/[chatId]" options={{ title: '' }} />
      <Stack.Screen
        name="[folderId]/settings"
        options={{
          title: 'Settings',
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
        }}
      />
      <Stack.Screen
        name="new-chat"
        options={{
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="[folderId]/new-chat"
        options={{
          presentation: 'modal',
          webModalStyle: {
            height: '90%',
            width: '95%',
          },
          headerShown: false,
        }}
      />
    </Stack>
  )
}
